module.exports = __webpack_public_path__ + "img/BAU Seniors_21.1bed9626.jpg";